import React from "react";
import English from "../../components/Nursery/English";
import EnglishMenu from "./English";
import Mathematics from "../../components/Nursery/Mathematics";
import MathematicsMenu from "./Mathematics";
import EnvironmentScience from "../../components/Nursery/EnvironmentScience";
import EnvironmentScienceMenu from "./EnvironmentScience";
import GeneralAwareness from "../../components/Nursery/GeneralAwareness";
import GeneralAwarenessMenu from "./GeneralAwareness";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; 
    subMenu?: MenuItem[]; 
}

// Define ClassTwoMenu with the proper type
const NurseryMenu: MenuItem[] = [
    { 
        url: "/nursery/english-language", 
        title: "English Language",
        component: English,
        subMenu: EnglishMenu
    },
    { 
        url: "/nursery/mathematics", 
        title: "Mathematics",
        component: Mathematics,
        subMenu: MathematicsMenu
    },
    { 
        url: "/nursery/environmental-science", 
        title: "Environmental Science (EVS)", 
        component: EnvironmentScience,
        subMenu: EnvironmentScienceMenu
    },
    { 
        url: "/nursery/general-awareness", 
        title: "General Awareness", 
        component: GeneralAwareness,
        subMenu: GeneralAwarenessMenu
    }
];

export default NurseryMenu;

